import { useTranslation } from '@msdk/common'
import { Badge, Box, CheckIcon, CloseIcon, styled, Typography, uiTokens } from '@msdk/ui'

import { PhotoCorrectExample } from './PhotoCorrectExample'
import { PhotoWrongExample } from './PhotoWrongExample'
import { StyledAccordion, StyledAccordionDetails, StyledAccordionSummary, StyledSummaryTypography } from './shared'

export const StyledDetailsTypography = styled(Typography)`
  display: flex;
  padding: ${uiTokens.spacing.padding.small}px ${uiTokens.spacing.padding.xSmall}px;
  align-items: center;
  gap: ${uiTokens.spacing.gap.small}px;
  align-self: stretch;
  overflow: hidden;
  color: ${uiTokens.uiContent.emphasized};
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: ${uiTokens.font.fontFamily.default};
  font-size: ${uiTokens.font.fontSize.uiControlText.medium}px;
  font-style: normal;
  font-weight: ${uiTokens.font.fontWeight.medium};
  line-height: ${uiTokens.font.lineHeight.uiControlText.medium}px; /* 128.571% */
  letter-spacing: ${uiTokens.font.letterSpacing.normal}px;
`

const StyledImagesBox = styled(Box)`
  display: flex;
  gap: 40px;
  padding-top: ${uiTokens.spacing.padding.small}px;
`

const StyledBadge = styled(Badge)`
  & .MuiBadge-badge {
    display: flex;
    width: ${uiTokens.sizing.icon.large}px;
    height: ${uiTokens.sizing.icon.large}px;
    justify-content: center;
    align-items: center;
    border-radius: 48px;
  }
`

export function PhotoGuidlines() {
  const t = useTranslation()

  return (
    <StyledAccordion>
      <StyledAccordionSummary aria-controls="panel2-content" id="panel2-header">
        <StyledSummaryTypography>
          {t('LBL_NGID_UPLOAD_PHOTO_GUIDLINES_TITLE', 'Photo guidlines')}
        </StyledSummaryTypography>
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        <StyledDetailsTypography>
          {t('LBL_NGID_UPLOAD_PHOTO_GUIDLINES_DESCR1', 'One person, looking straight at the camera, eyes open')}
        </StyledDetailsTypography>
        <StyledDetailsTypography>
          {t('LBL_NGID_UPLOAD_PHOTO_GUIDLINES_DESCR2', 'The face should occupy at least 75% of the image area')}
        </StyledDetailsTypography>
        <StyledDetailsTypography>
          {t('LBL_NGID_UPLOAD_PHOTO_GUIDLINES_DESCR3', 'Even lighting, plain background')}
        </StyledDetailsTypography>
        <StyledDetailsTypography>
          {t('LBL_NGID_UPLOAD_PHOTO_GUIDLINES_DESCR4', 'No hat, sunglasses, or face covering')}
        </StyledDetailsTypography>
        <StyledImagesBox>
          <StyledBadge badgeContent={<CheckIcon />} color="success">
            <PhotoCorrectExample />
          </StyledBadge>
          <StyledBadge badgeContent={<CloseIcon />} color="error">
            <PhotoWrongExample />
          </StyledBadge>
        </StyledImagesBox>
      </StyledAccordionDetails>
    </StyledAccordion>
  )
}
